<script setup lang="ts">
// Thin JAPAN/NIY instance of the generic FuturesMoveCard (generalised
// 2026-10-07, Charteris Phase 2.5 Task 4, so CHARTERIS's SI instance can
// reuse the same card). All NIY-specific wording lives in japanReasons.ts;
// this wrapper just supplies the fixed symbol/anchor-label/testid and binds
// the two JAPAN callback functions.
import FuturesMoveCard from '../fundtabs/FuturesMoveCard.vue'
import { describeJapanReason, japanAnchorNote } from './japanReasons'
import type { JapanSignal } from '../../api/client'

defineProps<{
  signal: JapanSignal
  todayLondon: string
}>()
</script>

<template>
  <FuturesMoveCard
    :signal="signal"
    :today-london="todayLondon"
    symbol="NIY"
    anchor-label="Tokyo close"
    test-id="niy-move-card"
    :describe="describeJapanReason"
    :anchor-note="japanAnchorNote"
  />
</template>
